<template>
    <section class="content">
      <box title="Filtro">
          <div slot="body">
            <div class="row">
              <div class="col-sm-5">
                <div class="input-group">
                  <input v-show="filtro==='ID'" style="height: 34px;" type="number" class="form-control" v-model="filter" placeholder="Pesquisa por ID">
                  <input v-show="filtro==='NOME'" style="height: 34px;" type="text" class="form-control" v-model="filter_name" placeholder="Pesquisa por NOME">
                  <div class="input-group-btn">
                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{filtro}} <span class="caret"></span></button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li><a href="javascript:;" @click="filtro='ID';filter=filter_name;filter_name=''">ID</a></li>
                      <li role="separator" class="divider"></li>
                      <li><a href="javascript:;" @click="filtro='NOME';filter_name=filter;filter=''">Nome</a></li>
                    </ul>
                  </div><!-- /btn-group -->
                </div><!-- /input-group -->
              </div><!-- /.col-lg-6 -->
              <div class="col-sm-3">
                <div class="form-group">
                  <select class="form-control" id="exampleFormControlSelect1" v-model="statuspedido">
                    <option :value="0">Todos Estados</option>
                    <option :value="1">Em Espera</option>
                    <option :value="2">Aprovado</option>
                    <option :value="3">Reprovado</option>
                    <option :value="6">Saiu para Entrega</option>
                    <option :value="5">Cancelado</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <router-link class="padding" to="/pedidos/relatorios" >
                    <button class="btn btn-primary" >
                      <i class="fa fa-line-chart" aria-hidden="true"></i>
                      Relatórios
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
            
            <br>
            <div class="row">
              <div class="col-sm-2 btn-group" data-toggle="buttons" >
                <label class="btn btn-primary radioOntem" @click="filtrarData('ontem')" id="radioOntem">
                  <input type="radio" autocomplete="off" > Ontem
                </label>
                <label class="btn btn-primary radioHoje" @click="filtrarData('hoje')" id="radioHoje">
                  <input type="radio" autocomplete="off" > Hoje
                </label>
              </div>
              <div class="col-sm-3">
                <div class="input-group">
                  <span class="input-group-addon" id="sizing-addon1" style="background: #367FA9; color: white;">Data Inicial</span>
                  <input type="date" class="form-control" aria-describedby="sizing-addon1" v-model="dataInicial" @change="filtrarData" style="height: 34px;">
                </div>
              </div>
              <div class="col-sm-3">
                <div class="input-group" >
                  <span class="input-group-addon" id="sizing-addon2" style="background: #367FA9; color: white;">Data Final</span>
                  <input type="date" class="form-control"  aria-describedby="sizing-addon2" v-model="dataFinal" @change="filtrarData" style="height: 34px;">
                </div>
              </div>
            </div>

            <!-- <br>
            <div class="">
              <div class="">
                <div class="btn-group" data-toggle="buttons">
                  <label class="btn btn-primary active" @click="filtraEstado('em espera')">
                    <input type="checkbox" autocomplete="off" > Em Espera
                  </label>
                  <label class="btn btn-primary" @click="filtraEstado('aprovado')">
                    <input type="checkbox" autocomplete="off" > Aprovado
                  </label>
                  <label class="btn btn-primary" @click="filtraEstado('reprovado')">
                    <input type="checkbox" autocomplete="off"> Reprovado
                  </label>
                  <label class="btn btn-primary" @click="filtraEstado('saiu para entrega')">
                    <input type="checkbox" autocomplete="off"> Saiu para Entrega
                  </label>
                  <label class="btn btn-primary" @click="filtraEstado('cancelado')">
                    <input type="checkbox" autocomplete="off"> Cancelado
                  </label>
                </div>
              </div>
            </div> -->
          </div>
      </box>

      <box>
        <div slot="body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
            <div class="row">
                <div class="col-sm-6">
                <div id="example1_length" class="dataTables_length">

                </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 table-responsive">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-borde#F48668 table-striped dataTable">
                    <thead>
                    <tr>
                        <th v-for="coluna in colunas">
                            <a href="javascript:;" @click="orderPedidos(coluna.json)" >
                              <div class="row">
                                <div class="col-sm-7">
                                  {{coluna.name | ucwords}}
                                </div>
                                <div class="col-sm-2">
                                  <i v-if="order.keys===coluna.json && order.sort==='asc'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                  <i v-else-if="order.keys===coluna.json && order.sort==='desc'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                  <i v-else-if="coluna.json!=='observacao' && coluna.json!=='acoes'" class="fa fa-sort" aria-hidden="true"></i>
                                </div>
                              </div>
                              </a>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="pedidosFiltered.length === 0">
                      <td colspan="12">Nenhum Pedido Localizado</td>
                    </tr>
                    <tr v-else class="even" role="row" v-for="(p, index) in pedidosFiltered">
                        <!-- <td><a href="javascript:;" @click="itens(index, p.id,  p.cliente.nome, p.cliente.contato, p.cliente, p.desconto)" data-toggle="modal" data-target="#modalLarge">{{p.id}}</a></td> -->
                        <td>{{p.cliente.nome | upperCase}}</td>
                        <!-- <td id="obs">{{p.observacoes}}</td> -->
                        <td>R$ {{p.preco_total ? p.preco_total.toFixed(2) : 0}}</td>
                        <td>{{p.data_hora | data}}</td>
                        <td v-if="p.estado.id == 1" style="background: #FFF95B" class="coluna">Em Espera</td>
                        <td v-if="p.estado.id == 2" style="background: #88D89D" class="coluna">Aprovado</td>
                        <td v-if="p.estado.id == 3" style="background: #F48668" class="coluna">Reprovado</td>
                        <td v-if="p.estado.id == 5" style="background: #F48668" class="coluna">Cancelado</td>
                        <td v-if="p.estado.id == 6" style="background: #88D89D" class="coluna">Saiu para Entrega</td>
                        <td style="text-align: center;">
                          <a title="Ver Pedido" class="iconPed" href="javascript:;" @click="itens(index, p.id,  p.cliente.nome, p.cliente.contato, p.cliente, p.desconto)" data-toggle="modal" data-target="#modalLarge"><i class="fa fa-search" aria-hidden="true"></i></a>
                          <a title="Aprovar" :class="p.estado.id != 1 ? 'iconPed disabled' : 'iconPed'" href="javascript:;" @click="gravarEstado(p.id, 2, p.cliente, p.cliente.nome, p.cliente.sobrenome, p.preco_total, p.estado.id)"><i class="fa fa-check" aria-hidden="true"></i></a>
                          <a title="Reprovar" :class="p.estado.id != 1 ? 'iconPed disabled' : 'iconPed'" href="javascript:;" @click="gravarEstado(p.id, 3, p.cliente, p.cliente.nome, p.cliente.sobrenome, p.preco_total, p.estado.id)"><i class="fa fa-ban" aria-hidden="true"></i></a>
                          <a title="Saiu para entrega" :class="p.estado.id != 1 && p.estado.id != 2 ? 'iconPed disabled' : 'iconPed'" href="javascript:;" @click="gravarEstado(p.id, 6, p.cliente, p.cliente.nome, p.cliente.sobrenome, p.preco_total, p.estado.id)"><i class="fa fa-bolt" aria-hidden="true"></i></a>
                        </td>
                    </tr>
                    <tr>
                      <td colspan="3" style="text-align: center">
                        <label>Total</label>
                      </td>
                      <td>
                        <label>R$ {{totalPedidos}}</label>
                      </td>
                    </tr>               
                    </tbody>
                    <tfoot>
                    <!-- <tr>
                        <th v-for="coluna in colunas">
                            <a href="javascript:;" @click="orderPedidos(coluna.json)">{{coluna.name | ucwords}}</a>
                        </th>
                    </tr> -->
                    </tfoot>
                </table>
                </div>
            </div>
            </div>

            <!-- /.box-body -->
        </div>
      </box>
   
        
       <!-- modal de visualizaçao pedido-->      
      <modal @imprimir="btnImprime" >
        <p slot="modal-title">
          Pedido {{pedido_id}} - {{dataPedido | data }}<br>
          {{nome_cliente.toUpperCase()}} <br>
          Telefone: {{contato}}<br>
        </p>
        <h3 slot="modal-body">
            <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table aria-describedby="example1_info" role="grid" id="" class="table table-borde#F48668 table-striped dataTable">
                      
                        <thead>
                        <tr v-if="artCasa">
                          <th v-for="coluna2 in colunas_itens2" >
                            {{coluna2 | ucwords}}
                          </th>
                        </tr>
                        <tr v-else>
                          <th v-for="coluna in colunas_itens">
                            {{coluna | ucwords}}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="even" role="row" v-for="item in itens_pedido">
                            <td v-if="artCasa"><img :src="item.img" alt="" style="max-width: 50%;"></td>
                            <td class="bordaItem">{{item.qtde}}</td>
                            <td class="bordaItem">
                              {{item.nome}} {{config.imprimir_descricao && item.descricao && item.descricao.length < 50 ? `(${item.descricao})` : ''}}
                              <p v-if="item.adicionais" v-for="adc in item.adicionais" class="adicionais">
                                + {{adc.qtde}} - {{adc.produtos.nome}}
                              </p>
                            </td>
                            <!-- <td>{{item.observacao}}</td> -->
                            <td>R$ {{item.total ? item.total.toFixed(2) : 0}}</td>
                        </tr>
                                              
                        </tbody>
                    </table>
                  </div>
                  
              </div>
              <div class="row">
                <div class="col-sm-4 table-responsive" style="margin-top: 2%" id="">
                    <table  aria-describedby="example1_info" role="grid" class="table table-borde#F48668 table-striped dataTable">
                      <thead>
                        <tr>
                          <th v-for="coluna in colunas_pagamento">
                            {{coluna | ucwords}}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="p in pagamento">
                          <td>{{p.pagamento.nome}}</td>
                          <td v-if="p.pagamento.nome.toLowerCase() !== 'dinheiro'">{{p.observacao}}</td>
                          <td v-else>Troco para: R${{p.observacao}} <h5>(R${{(parseInt(p.observacao) - total_pedido).toFixed(2)}})</h5> </td>
                        </tr>
                      </tbody>
                    </table>
                    <br>
                    -------------------------------------
                    <div v-show="desconto && desconto > 0">
                      <label style="font-size: 15px; padding-right:5em">Desconto: {{desconto}}% (Primeira Compra) </label>
                    </div>
                    <!-- <br> -->
                    <label style="font-size: 15px; padding-right:5em">Total do Pedido</label><label style="font-size: 15px;">{{total_pedido.toFixed(2)}}</label>
                  </div>
                  <div class="col-sm-8 endereco" style="margin-top: 3%" >
                      <div class="endereco-title">
                      <label style="font-size: 15px">Endereço de Entrega</label>
                      </div>
                      <div class="endereco-body" id="endereco">
                        <div v-if="endereco">
                          <label class="lblEnd End">Rua: {{endereco.rua}}</label><br>
                          <label class="lblEnd End">Número: {{endereco.numero}}</label><br>
                          <label class="lblEnd End">Bairro: {{endereco.bairro}}</label><br>
                          <label class="lblEnd End">Complemento: {{endereco.complemento}}</label>
                        </div>
                        <div v-else>
                          <label>Irá Retirar</label>
                        </div>
                      </div>
                  </div>
              </div>
        </h3>
      </modal>

      <div style="display: none">
        <div id="titlePedido">
          <label class="idPedido">Pedido {{pedido_id}} - {{dataPedido | data }}</label><br>
          {{nome_cliente.toUpperCase()}} <br>
          Telefone: {{contato}}<br>
        </div>
        <div class="row">
          <div class="col-sm-12 table-responsive" id="itensTable">
            <div class="row">
                <label>ITENS</label>
            </div>
            <div v-for="item in itens_pedido">
                {{item.qtde}} - R$ {{item.total.toFixed(2)}} - {{item.nome}} {{config.imprimir_descricao && item.descricao && item.descricao.length < 50 ? `(${item.descricao})` : ''}}
                <div v-if="item.adicionais" v-for="adc in item.adicionais" class="adicionais">
                  + {{adc.qtde}} - {{adc.produtos.nome}}
                </div>
                <br>-------------------------------------------
            </div>
          </div>
      </div>
      <div class="row">
          <div class="col-sm-4 table-responsive" style="margin-top: 2%" id="pagamento">
                  <div v-for="coluna in colunas_pagamento">
                      {{coluna }}
                  </div>
                  <div v-for="p in pagamento">
                      <label>{{p.pagamento.nome}}</label>
                      <label v-if="p.pagamento.nome !== 'dinheiro'">{{p.observacao}}</label>
                      <label v-else>Troco: R${{(parseInt(p.observacao) - total_pedido).toFixed(2)}} (Troco para R${{p.observacao}})</label>
                  </div>
              -------------------------------------------
              <div v-show="desconto && desconto > 0">
                Desconto: {{desconto}}%
              -------------------------------------------
              </div>
              <br><label style="font-size: 15px">Total do Pedido: {{total_pedido.toFixed(2)}}</label>
          </div>
          <div class="col-sm-8 endereco" style="margin-top: 3%" >
              <div class="endereco-title">
              <label style="font-size: 15px">Endereço de Entrega</label>
              </div>
              <div class="endereco-body" id="endereco">
                  <div v-if="endereco">
                      <label class="lblEnd">Rua: {{endereco.rua}}</label><br>
                      <label class="lblEnd">Numero: {{endereco.numero}}</label><br>
                      <label class="lblEnd">Bairro: {{endereco.bairro}}</label><br>
                      <label class="lblEnd">Complemento: {{endereco.complemento}}</label>
                  </div>
                  <div v-else>
                      <label class="lblEnd">Irá Retirar</label>
                  </div>
              </div>
          </div>
      </div>
    </div>
        <!--
        <download-excel
          class   = "btn btn-default"
          :data   = "json_data"
          :fields = "json_fields"
          name    = "filename.xls">
          Download Excel (you can customize this with html code!)
        </download-excel>
        -->
        <!-- Modal -->
         
    </section>
</template>

<script>
import axios from 'axios'
import Modal from '../Modal-Large' // importando modal com largura 1000px
import JsonExcel from 'vue-json-excel';
import _ from 'lodash'
import Box from '../Box'

export default {
  name: 'Pedidos',
  components: {
    'modal': Modal,
    'downloadExcel': JsonExcel,
    'box': Box,
  },
  data () {
    return {
      artCasa: localStorage.getItem('FB_ID') === '373108266747843' ? true : false,
      imprimir: false,
      order: {
        keys: 'estado.id',
        sort: 'asc'
      },
      filter: '',
      filter_name: '',
      filter_status: ['em espera'],
      pagamento: [],
      endereco: null,
      filtro: 'ID',
      colunas_pagamento: ['Formas Pagamento',''],
      colunas: [
        // {
        //   name : 'id',
        //   json: 'id'
        // },
        {
          name : 'cliente',
          json: 'cliente.nome'
        },
        // {
        //   name : 'observação',
        //   json: 'observacao'
        // },
        {
          name : 'total',
          json: 'preco_total'
        },
        {
          name : 'data hora',
          json: 'data_hora'
        },
        {
          name : 'estado',
          json: 'estado.id'
        },
        {
          name: 'Ações',
          json: 'acoes'
        }
      ],
      colunas_itens: ['quantidade', 'nome', 'preco'],
      colunas_itens2: ['Foto', 'quantidade', 'nome', 'preco'],
      colunas_impressao: ['Qtd', 'Item', 'Preco'],
      pedidos: [],
      estados: [],
      pedido_id: 0,
      nome_cliente: '',
      contato: '',
      itens_pedido: [],
      config: [],
      total_pedido: 0,
      dataInicial: '',
      dataFinal: '',
      hoje: false,
      ontem: false,
      pedidosFiltrados: [],
      statuspedido: 0,
      desconto: 0
    }
  },
  created () {
    this.getPedido()
    this.getEstado()
    this.getConfig()
  },
  methods: {
    filtraEstado(estado) {
      for(var index in this.filter_status){
        if(this.filter_status[index]===estado){
          this.filter_status.splice(index, 1)
          return
        }
      }
      this.filter_status.push(estado)
    },
    filtrarData(dia) {

      var hoje = new Date();

      var ontem = new Date(hoje.getTime());
      ontem.setDate(hoje.getDate() - 1);

      console.log(dia)
      if(dia === 'ontem') {
        if(this.ontem) {
          this.ontem = false
          this.dataInicial = ''
          this.dataFinal = ''
          console.log('remove calsse')
          setTimeout(() => {
            var element = document.getElementById("radioOntem");
            element.classList.remove("active");
          }, 100)
          return
        } 
        this.ontem = true;
        this.hoje = false;
        this.dataFinal = this.getData(ontem);
        this.dataInicial = this.dataFinal;
      } else if (dia === 'hoje'){
        if(this.hoje) {
          this.hoje = false
          this.dataInicial = ''
          this.dataFinal = ''
          console.log('remove calsse')
          setTimeout(() => {
            var element = document.getElementById("radioHoje");
            element.classList.remove("active");
          }, 100)
          return
        } 
        this.ontem = false;
        this.hoje = true;
        this.dataFinal = this.getData(hoje);
        this.dataInicial = this.dataFinal;
      } else {
        console.log(this.dataFinal)
        this.ontem = false;
        this.hoje = false;
        setTimeout(() => {
          var element = document.getElementById("radioOntem");
          var element2 = document.getElementById("radioHoje");
          element.classList.remove("active");
          element2.classList.remove("active");
        }, 100)
      }
    },
    getData(data) {
      let year = data.getFullYear().toString();
      let month = (data.getMonth()+1).toString();
      let day = data.getDate().toString();
      return `${year}-${month.length < 2 ? '0'+month : month}-${day.length < 2 ? '0'+day : day}`
    },
    getPedido () {
      axios.get(`${this.$store.state.api}pedidos?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.pedidos = response.data
        for(var pedido in this.pedidos) {
          if(this.pedidos[pedido].data_hora_conclusao) this.pedidos[pedido].data_hora = this.pedidos[pedido].data_hora_conclusao
          this.pedidos[pedido].cliente.nome = this.pedidos[pedido].cliente.nome + ' '+ this.pedidos[pedido].cliente.sobrenome
        }
        console.log('get pedido -> ', this.pedidos)
      })
    },
    getPagamento(id) {
      axios.post(this.$store.state.api+'pagamentos', {
          'pedidos_id' : id
      }).then(response => {
        this.pagamento = response.data
        // for(var index in this.pagamento){
        //   if (this.pagamento[index].observacao){
        //     this.pagamento[index].observacao = 'Troco para R$'+this.pagamento[index].observacao
        //   }
        // }
      })
    },
    getEndereco(cliente_fb_id, pedido) {
      axios.post(this.$store.state.api+'enderecos', {
        'cliente_fb_id': cliente_fb_id,
        'pedido': pedido
      }).then(response => {
        console.log('endereço ==> ', response)
        if(response.data) {
          this.endereco = response.data.enderecos ? response.data.enderecos : response.data[0];
        }
        else this.endereco = null
      })
    },
    getEstado () {
      axios.get(this.$store.state.api+'estados').then(response => {
        for (var i = 0; i < response.data.length; i++) {
          if (response.data[i].id !== 4 && response.data[i].id !== 5) this.estados.push(response.data[i])
        }
      })
    },
    getConfig() {
      axios.get(`${this.$store.state.api}config?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.config = response.data[0]
      })
    },
    itens (index, id, nome, contato, cliente , desconto) {
      console.log('clientes ===> ', cliente)
      let clientes_fb_id = cliente.fb_id ? cliente.fb_id : cliente.facebook_id;
      this.total_pedido = this.pedidosFiltered[index].preco_total ? this.pedidosFiltered[index].preco_total : 0 
      this.dataPedido = this.pedidosFiltered[index].data_hora_conclusao ? this.pedidosFiltered[index].data_hora_conclusao : this.pedidosFiltered[index].data_hora
      this.getPagamento(id)
      this.getEndereco(clientes_fb_id, id)
      this.pedido_id = id
      this.nome_cliente = nome
      this.contato = contato
      this.desconto = desconto
      axios.get(this.$store.state.api+'pedidos/itens/' + id).then(response => {
        this.ordenaItens(response.data)
      })
    },
    ordenaItens(itens) {
      console.log('itens-> ', itens)
      this.itens_pedido = []
      let prodName=''
      let qtde=0
      let obs= ''
      let img = ''
      for (var i = 0 ; i < itens.length; i++) {
        for (var j = 0; j < itens[i].itens.length; j++) {
          if(prodName != '') prodName += '/ \n' + itens[i].itens[j].produtos.nome
          else prodName = itens[i].itens[j].produtos.nome

          if(obs != '') obs += '/ ' + itens[i].itens[j].observacao 
          else obs = itens[i].itens[j].observacao      
          
          img = itens[i].itens[j].produtos.url_imagem
        }
        if(j > 1) qtde = 1
        else qtde = itens[i].itens[j-1].quantidade

        let massa = ''
        if(itens[i].tipo_massa) massa = ' - ' + itens[i].tipo_massa
        if(itens[i].tipo_borda) massa += ' / ' + itens[i].tipo_borda
        
        if(obs !== '') obs += massa
        else obs = massa
        if (obs !== '') prodName += ' (' + obs + ')'

        let nomeProduto;

        if(itens[i].cardapio && itens[i].cardapio.nome.indexOf('Pizza') != -1 ) nomeProduto = `${itens[i].cardapio.nome} - ${prodName}`;
        else nomeProduto = prodName;

        let descricao = itens[i].itens[0].produtos.descricao ? itens[i].itens[0].produtos.descricao.split('.')[0] : ''

        let total = 0;

        itens[i].adicionais.forEach((adicional) => {
          total += (adicional.preco * adicional.qtde)
        });

        total += itens[i].preco_item;

        this.itens_pedido.push({nome: nomeProduto, descricao, img, qtde: qtde, observacao: obs, total, preco: itens[i].preco_item, adicionais: itens[i].adicionais ? itens[i].adicionais : null})
        console.log('itens pedido => ', this.itens_pedido)
        prodName = ''
        obs = ''

      }
    },
    orderPedidos (coluna) {
      console.log('ordenar coluna => ', coluna)
      if(coluna !== 'observacao') {
        this.order.keys = coluna
        this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc'
      }
    },
    btnImprime () {
      axios.get(this.$store.state.api + 'pedidos/imprimiu?id=' + this.pedido_id)
      this.imprimir = true
      setTimeout(() => {
        var title = document.getElementById('titlePedido').innerHTML,
        endereco = document.getElementById('endereco').innerHTML,
        itens = document.getElementById('itensTable').innerHTML,
        pagamento = document.getElementById('pagamento').innerHTML,
        // obs = document.getElementById('obs').innerHTML,
        tela_impressao = window.open('about:blank');

        tela_impressao.document.write(title);
        tela_impressao.document.write('<br>');      
        tela_impressao.document.write(endereco);      
        tela_impressao.document.write('<br><br>');      
        tela_impressao.document.write(itens);
        tela_impressao.document.write('<br><br>');      
        tela_impressao.document.write(pagamento);
        tela_impressao.document.write('<br><br>');
        tela_impressao.document.write('<style> table {text-align: center} .lblEnd{margin-top:-1%} label {font-size: 12px!important;} tr {font-size: 12px;} th{font-size: 12px;} h4 {font-size: 12px; margin-bottom: 1%} p {font-size: 12px;} h5 {margin: 0px} .adicionais { font-size: 11px; margin: 0 } .bordaItem{ border-bottom: 1px dotted }</style>');      
        tela_impressao.window.print();
        tela_impressao.window.close();
        this.imprimir = false;
      },2000)
    },
    gravarEstado (id, estado, cliente, nome, sobrenome, preco_total, estadoAtual) {
      console.log('**** gravar estado')
      let fb_id = cliente.fb_id ? cliente.fb_id : cliente.facebook_id;
      axios.post(this.$store.state.api+'pedidos/alter-status', {
        'id_estado': estado,
        'id_pedido': id
      }).then(response => {
        if (response.data.success === 'true') {
          this.getPedido() // busca novamente os pedidos
          var textarea
          if(estado===2) textarea = this.config.texto_padrao_aprovado
          else if(estado===3) textarea = this.config.texto_padrao_reprovado
          else if(estado===5) textarea = this.config.texto_padrao_cancelado
          else if(estado===6) textarea = this.config.texto_padrao_entrega

          textarea = textarea.split('#NOME').join(nome)
          textarea = textarea.split('#SOBRENOME').join(sobrenome)
          textarea = textarea.split('#IDPEDIDO').join(id)
          textarea = textarea.split('#FACEID').join(fb_id)
          textarea = textarea.split('#PRECOTOTAL').join(preco_total)
          textarea = textarea.split('#TEMPOENTREGA').join(this.config.tempo_entrega)
          this.getPedido()
          this.notifca_cliente(textarea,estado,fb_id);
          
        } else {
          this.$swal(
            'Ops!',
            'Não foi possivel alterar o status. Nenhuma alteração foi realizada.',
            'error'
          )
        }
      })
      
    },
    notifca_cliente (msg, estado, fb_id) {
      let url= this.$store.state.api_bot+'pedidos/estado_pedido?fb_id='+fb_id+'&estado='+estado+'&msg='+msg

      axios.get(url).then(response => {
        // this.$swal({
        //     position: 'top-end',
        //     type: 'success',
        //     title: 'Cliente Notificado',
        //     showConfirmButton: false,
        //     timer: 1500
        //   })   
      })
    }
  },
  filters: {
    ucwords (value) {
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    upperCase(value) {
      return value.toUpperCase()
    },
    data (value) {
      var data = new Date(value)
      var dia = data.getDate()
      var mes = data.getMonth() + 1
      var ano = data.getFullYear()
      var hr = data.getHours()
      var min = data.getMinutes()
      return dia + '/' + mes + '/' + ano + ' - ' + hr + ':' + min
    }
  },
  computed: {
    pedidosFiltered () {
      console.log('estado pedido ==> ', this.statuspedido)
      var pedidosAjustados = this.pedidos
      this.filter_name = this.filter_name.toLowerCase()
      let colecao = _.orderBy(pedidosAjustados, this.order.keys, this.order.sort)

      if(this.dataInicial && this.dataFinal) {
        
        this.pedidosFiltrados =  _.filter(colecao, item => {
          console.log('itens ==> ', item)
          return item.id.indexOf(this.filter) >= 0 && item.cliente.nome.indexOf(this.filter_name) >= 0 && item.data_hora.split('T')[0] <= this.dataFinal && item.data_hora.split('T')[0] >= this.dataInicial && (this.statuspedido !== 0 ? item.estadospedidos_id === this.statuspedido : true)
        })
        return this.pedidosFiltrados;
      }

      this.pedidosFiltrados = _.filter(colecao, item => {
        console.log('itens ==> ', item)
        return item.id.indexOf(this.filter) >= 0 && item.cliente.nome.toLowerCase().indexOf(this.filter_name) >= 0 && (this.statuspedido !== 0 ? item.estadospedidos_id === this.statuspedido : true)
      })
      return this.pedidosFiltrados;
    },
    totalPedidos() {
      let total = 0;
      this.pedidosFiltrados.forEach(pedido => {
        total += pedido.preco_total;
      });
      return total.toFixed(2)
    }
  }
}
</script>
<style scoped>

.coluna {
    width:190px;
}
.url_imagem {
    width: 80px;
}
td, th {
      font-size: 15px;
  }

.endereco-title{
  text-align: center
}
.endereco-body{
  text-align: center;
  /* margin-top: 3% */
}
.End {
  font-size: 15px
}
.adicionais {
  font-size: 12px;
  font-style: italic;
  margin: 0
}
.iconPed{
  padding: 1em;
}
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: -5px;
  left: 105%;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

a.disabled {
  /* pointer-events: none; */
  cursor: not-allowed;
  /* color: grey */
  display: none
}
</style>



// WEBPACK FOOTER //
// Pedidos.vue?e1416188